import axios from 'axios'
import store from '@/store'
import router from "@/router";
import {toast} from "../class/Notification";
import {findObjectIndex} from "../class/Converter";
import {queryBuilder, filters} from '../class/QueryFilter'

let filtersCopy = JSON.parse(JSON.stringify(filters))


export default {
    namespaced: true,
    state: {
        ...filtersCopy,
    },
    mutations: {
        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
    },
    actions: {
        addItemToWishList({commit}, form) {
            let req = axios.post('/wishlist/user', form)

            req.then(res => {
                toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت ثبت شد.')
            }).catch(error => {
                console.log(error)
            })

            return req
        },
        removeItemFromWishList({commit}, form) {
            let req = axios.post(`/wishlist/${form.id}`, form)

            req.then(res => {
                toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت ثبت شد.')
            }).catch(error => {
                console.log(error)
            })

            return req
        },
        loadUserWishList({commit, state}, form) {
            // convert filter items to query string
            const query = queryBuilder(state.filters)
            let req = axios.get(`/wishlist/user/${form.user_id}?page=${form.page}&${query}`)
            return req
        },
        checkItemWishListed({commit}, form) {
            let req = axios.post(`check-item/wishlist`, form)
            return req
        },
    },
    getters: {
        getFilters: (state) => state.filters,
    }
}